/**
 * AdminSettingsPage — iter171
 *
 * Routed page wrapper for the Admin Settings surface. The
 * underlying `AdminPanel` component is rendered in `mode="page"` so
 * it sheds its fixed-overlay chrome and uses a normal flowing
 * full-width layout (HeaderBrand on top, Back button + tabs/body
 * card below).
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import HeaderBrand from "@/components/HeaderBrand";
import AdminPanel from "@/components/AdminPanel";


export default function AdminSettingsPage({ user }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.email) navigate("/", { replace: true });
  }, [user?.email, navigate]);

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-settings-page">
      <HeaderBrand user={user} />
      <AdminPanel user={user} mode="page" onClose={handleBack} />
    </div>
  );
}
